export default __webpack_public_path__ + "static/media/Resume.01ec2166.pdf";